import { Reducer } from "react";
import { getNextMonth, getNextYear, getPreviousMonth, getPreviousYear } from "../../utils/date-utils";
import { CalendarActions } from "./actions";

export interface CalendarState {
  open: boolean;
  preSelectionDate: Date;
  focusOnDate: boolean;
  rangeHoverDay: Date | null;
  inputValue: string | null;
}

export const calendarInitialState: CalendarState = {
  open: false,
  preSelectionDate: new Date(),
  focusOnDate: true,
  rangeHoverDay: null,
  inputValue: null,
};

export const calendarReducer: Reducer<CalendarState, CalendarActions> = (
  calendarState = calendarInitialState,
  action
) => {
  switch (action.type) {
    case "SET_CALENDAR_OPEN_STATE":
      return {
        ...calendarState,
        focusOnDate: true,
        open: action.open,
        rangeHoverDay: null,
      };
    case "SET_PRE_SELECTION_DATE":
      return {
        ...calendarState,
        focusOnDate: action.focusOnDate,
        preSelectionDate: action.date,
        inputValue: null,
      };
    case "SET_INPUT_VALUE":
      return {
        ...calendarState,
        inputValue: action.value,
      };
    case "SET_RANGE_HOVER_DAY":
      return {
        ...calendarState,
        focusOnDate: true,
        rangeHoverDay: action.day,
      };
    case "SET_PREVIOUS_MONTH":
      return {
        ...calendarState,
        focusOnDate: false,
        preSelectionDate: getPreviousMonth(calendarState.preSelectionDate, action.step),
      };
    case "SET_NEXT_MONTH":
      return {
        ...calendarState,
        focusOnDate: false,
        preSelectionDate: getNextMonth(calendarState.preSelectionDate, action.step),
      };
    case "SET_PREVIOUS_YEAR":
      return {
        ...calendarState,
        focusOnDate: false,
        preSelectionDate: getPreviousYear(calendarState.preSelectionDate),
      };
    case "SET_NEXT_YEAR":
      return {
        ...calendarState,
        focusOnDate: false,
        preSelectionDate: getNextYear(calendarState.preSelectionDate),
      };
    default:
      return calendarState;
  }
};
